import axios from 'axios/index';
import { SET_USER_DATA } from '../../utils/constants';

const setUserData = async (data, hash, token) => {

    return await axios.put(SET_USER_DATA(token),
        data, {
        headers: {
            "Accept": "application/json",
            "Accept-language": "bg",
            "Authorization": hash,
        }
    }).then(resp => {
        // console.log(resp)
        // return resp.data;
    }).catch(err => {
        console.error(err)
    })
}

export default setUserData;